import styled from 'styled-components'

export const Section = styled.section`
  width: 100%;
  margin-top: 148px;
  padding: 0 24px;
  display: flex;
  justify-content: center;
  box-sizing: border-box;

  @media (max-width: 900px) {
    margin-top: 64px;
    padding: 0 16px;
  }
`

export const Container = styled.div`
  width: 100%;
  max-width: var(--unsignedMaxWidth);
  min-height: 364px;
  background: linear-gradient(95deg, #e6e9f4 0%, #d0d5f0 100%);
  display: flex;
  flex-direction: row;
  align-items: stretch;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 48px 0 0 60px;
  position: relative;
  overflow: hidden;

  @media (max-width: 900px) {
    flex-direction: column;
    align-items: center;
    min-height: unset;
    padding: 40px 24px;
    gap: 32px;
  }
`

export const LeftCol = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;

  @media (max-width: 900px) {
    align-items: center;
    text-align: center;
    width: 100%;
  }
`

export const Title = styled.h2`
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  font-size: 28px;
  line-height: 130%;
  color: var(--blue6, #21105d);
  margin-bottom: 24px;

  @media (max-width: 900px) {
    font-size: 22px;
    text-align: center;
    margin-bottom: 16px;
  }
`

export const DownloadRow = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 49px;

  @media (max-width: 900px) {
    flex-direction: column;
    gap: 16px;
    margin-bottom: 32px;
  }
`

export const DownloadText = styled.span`
  font-family: 'Inter', sans-serif;
  font-weight: 600;
  font-size: 16px;
  color: #495057;
  margin-right: 20px;

  @media (max-width: 900px) {
    margin-right: 0;
  }
`

export const StoreLogos = styled.div`
  display: flex;
  align-items: center;
  gap: 36px;
`

export const AppButton = styled.button`
  width: 246px;
  height: 64px;
  border-radius: 10px;
  padding: 16px;
  gap: 10px;
  background: #5039dd;
  color: #fff;
  font-family: 'Inter', sans-serif;
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 0;
  margin-bottom: 0;
  transition: background 0.2s;

  &:hover {
    background: #3d2db3;
  }

  @media (max-width: 900px) {
    width: 100%;
    max-width: 280px;
  }
`

export const RightCol = styled.div`
  width: 540px;
  height: 295px;
  position: relative;
  align-self: flex-end;
  flex-shrink: 0;

  @media (max-width: 900px) {
    width: 100%;
    max-width: 428px;
    height: 295px;
    align-self: center;
    margin-top: 24px;
  }
`

export const PhoneImg = styled.div`
  position: absolute;
  left: -120px;
  bottom: 0;
  width: 169px;
  height: 223px;
  z-index: 2;

  @media (max-width: 480px) {
    width: 130px;
    height: 171px;
    left: 0;

    img {
      width: 100% !important;
      height: auto !important;
    }
  }
`

export const TabletImg = styled.div`
  position: absolute;
  right: 40px;
  bottom: 30px;
  width: 428px;
  height: 295px;
  z-index: 1;

  @media (max-width: 900px) {
    width: 100%;
    max-width: 428px;
    height: auto;
    right: 0;
    bottom: 0;

    img {
      width: 100% !important;
      height: auto !important;
    }
  }
`
